import React, { FormEvent } from "react";
import "./authMobileComponents.scss";
import SiteTexts from "utils/Texts";
import { Addresses } from "utils/Addresses";
import TextInput from "components/Input/TextInput";
import { Labels } from "utils/Labels";
import { LoginError } from "JsFunctions/Auth/Login";
import CustomModal from "components/Modal/CustomModal";
import { onlyNumber } from "utils/rejex";

interface Props {
  mobile: number;
  setMobile: React.Dispatch<React.SetStateAction<string>>;
  otp: string;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
  error: LoginError;
  submitLogin: () => void;
  allowToSubmit: boolean;
  loginStep: 1 | 2;
}

const LoginMobilePage: React.FC<Props> = ({
  mobile,
  setMobile,
  otp,
  setOtp,
  error,
  submitLogin,
  allowToSubmit,
  loginStep,
}) => {
  const SiteText = SiteTexts();
  return (
    <>
      <div
        style={{
          backgroundImage: `url("${Addresses.images.LOGIN_BACKGROUND}")`,
        }}
        className="login-container"
      >
        <div className="login-form-parent">
          <h1>{SiteText.LOGIN.LOGIN_TITLE}</h1>
          <form onSubmit={submitLogin}>
            {loginStep === 1 ? (
              <div className="input-parent">
                <TextInput
                  lable={""}
                  value={mobile}
                  className={"login-input"}
                  error={error.mobileError}
                  autoFocus={true}
                  regex={onlyNumber}
                  required={true}
                  type={"tel"}
                  name={"mobile"}
                  onChangeValue={setMobile}
                  removeLable={true}
                  placeholder={"mobile number"}
                  maxlength={11}
                  key={loginStep}
                />
              </div>
            ) : (
              <div className="input-parent">
                <TextInput
                  lable={""}
                  value={otp}
                  className={"login-input"}
                  error={error.otpError}
                  autoFocus={false}
                  regex={onlyNumber}
                  required={true}
                  type={"tel"}
                  name={"otp"}
                  onChangeValue={setOtp}
                  removeLable={true}
                  placeholder={"otp"}
                  maxlength={11}
                />
              </div>
            )}
            <button type={"submit"} className="btn">
              {allowToSubmit
                ? Labels.ButtonLabels.LOGIN
                : Labels.ButtonLabels.Waiting}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginMobilePage;
